import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2900neba77: FaireBrandEntity = {
  token: "b_2900neba77",
  type: "brand",
  name: "Meagan Meli Illustration",
  avatarUrl:
    "https://cdn.faire.com/fastly/93b8f078b7f0593194740b4b86e7b9560b9e4759e96ab9030a531aabedc9aa34.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b01ae9dea18b99d301ef6efb0d909e80e1a07d752e6bb5be0139e9bcf2cf1e0f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/93b8f078b7f0593194740b4b86e7b9560b9e4759e96ab9030a531aabedc9aa34.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b01ae9dea18b99d301ef6efb0d909e80e1a07d752e6bb5be0139e9bcf2cf1e0f.jpeg",
  location: "Cranford, NJ, USA",
  minimumOrderDollars: 120,
  rating: 5,
  reviewCount: 15,
  isTopShop: true,
  isInsider: true,
  description:
    "Meagan Meli is an illustrator based in Cranford, New Jersey, whose artwork blends whimsical charm with macabre themes. Drawing inspiration from vintage Halloween illustrations, 20th-century Disney color palettes, and cemetery symbolism, her creations evoke a playful yet poignant atmosphere. Her work often explores themes of death, grieving, and mourning, aiming to provide comfort and a sense of acceptance toward life's inevitable end.\nMeagan's illustrations are characterized by their use of bright, bold colors and stylized forms, reminiscent of vintage Halloween art. Despite the dark subject matter, her pieces maintain a lighthearted and approachable quality, inviting viewers to reflect on mortality without fear. These artworks often feature intricate details and a harmonious color palette, showcasing Meli's skillful technique and unique artistic voice.\nFor those interested in exploring her work further, Meagan Meli offers original art, prints, and other items through her online shop. Each piece is crafted with care, reflecting her dedication to creating art that resonates with those who appreciate the beauty in life's darker aspects.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:44.604Z",
    importedBy: "entity-db-cli",
  },
};
